const isDev = process.env.NODE_ENV === "development";

/**
 * Log error messages (console.error)
 */
export function logError(error, context = "") {  
  if (context) {
    console.error(`❌ [${context}]`, error);
  } else {
    console.error("❌", error);
  }
}

/**
 * Log warning messages (console.warn)
 */
export function logWarn(message, context = "") {
  if (!isDev) return;  
  
  if (context) {
    console.warn(`⚠️ [${context}] ${message}`);
  } else {
    console.warn(`⚠️ ${message}`);
  }
}

/**
 * Log normal info/debug (console.info)
 */
export function logInfo(message, context = "") {
  if (!isDev) return;
  
  if (context) {
    console.log(`ℹ️ [${context}] ${message}`);
  } else {
    console.log(`ℹ️ ${message}`);
  }
}
